<script>
import { CHANNEL_TYPE } from '../enums'

export default {
  name: 'ButtonText',
  functional: true,
  render(h, { props }) {
    const el =
      props.channelType === CHANNEL_TYPE.CRYPTO
        ? h('b', { class: 'a-join-telegram__text_yellow' }, ' Crypto ')
        : ' '
    return h('span', { class: ['a-join-telegram__text'] }, [
      'Join our',
      el,
      h('b', 'Telegram'),
      ' channel'
    ])
  }
}
</script>

<style lang="scss" scoped>
.a-join-telegram__text {
  font-size: 15px;
  line-height: 20px;
  margin-left: 5px;
  color: white;

  & > * {
  }

  &_yellow {
    color: #ffde00;
  }
}
</style>
